<template>
  <notifications />
  <router-view />
</template>
